import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["trigger", "field"]
    static values = ["group"]

    triggerTargetConnected(trigger) {
        {
            console.log("trigger", trigger.dataset.resetAllGroupValue);
            trigger.addEventListener("click", this.resetAll)
        }
    }

    resetAll = (evt) => {
        evt.preventDefault();

        const trigger = evt.currentTarget;
        const group = trigger.dataset.resetAllGroupValue
        console.log("resetAll", group, trigger, evt)

        this.fieldTargets.forEach((field) => {
            const fieldGroup = field.dataset.resetAllGroupValue
            if (fieldGroup === group) {
                console.log("resetting", group, fieldGroup, field)
                field.value = ""
                this.triggerInputEvent(field)
            }
        })
    }

    triggerInputEvent(field) {
        const event = new Event("input", {bubbles: false, cancelable: true});

        field.dispatchEvent(event);
    }
}
